import { c as _c } from "react-compiler-runtime";
import { useEffect, useCallback } from 'react';
import { useMessageBus } from './useMessageBus';
import { useCrmMessagingContext } from './CrmMessagingContext';
import { useRegisterHandler } from './MessageBusSpyContext';
function getMessageSource(envelope = {}) {
  return envelope.sourceId;
}
function getMessageTarget(envelope = {}) {
  return envelope.targetId;
}
function getCurrentMessagingId(messageContext) {
  if (!messageContext) {
    return undefined;
  }
  return messageContext.messagingId;
}
function messageCameFromCurrentMessenger(messageContext, envelope = {}) {
  const currentMessagingId = getCurrentMessagingId(messageContext);
  const messageSource = getMessageSource(envelope);
  return !!messageSource && messageSource === currentMessagingId;
}
export function useOnCrmMessageTopic(topic, onTopic, config) {
  const $ = _c(11);
  const messageBus = useMessageBus();
  const messagingContext = useCrmMessagingContext();
  const registerHandler = useRegisterHandler();
  const skip = config && config.skip;
  let t0;
  if ($[0] !== config || $[1] !== messagingContext || $[2] !== onTopic) {
    t0 = envelopeData => {
      const {
        data,
        envelope
      } = envelopeData;
      if (config && config.ignoreLocal && messageCameFromCurrentMessenger(messagingContext, envelope)) {
        return;
      }
      const target = getMessageTarget(envelope);
      if (target && target !== getCurrentMessagingId(messagingContext)) {
        return;
      }
      onTopic(data);
    };
    $[0] = config;
    $[1] = messagingContext;
    $[2] = onTopic;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const cbWrapper = t0;
  let t1;
  let t2;
  if ($[4] !== cbWrapper || $[5] !== messageBus || $[6] !== registerHandler || $[7] !== skip || $[8] !== topic) {
    t1 = () => {
      if (!messageBus || skip) {
        return _temp;
      }
      registerHandler === null || registerHandler === void 0 || registerHandler(topic);
      const unsubscribe = messageBus.subscribe(topic, cbWrapper);
      return () => {
        unsubscribe();
      };
    };
    t2 = [messageBus, topic, cbWrapper, skip, registerHandler];
    $[4] = cbWrapper;
    $[5] = messageBus;
    $[6] = registerHandler;
    $[7] = skip;
    $[8] = topic;
    $[9] = t1;
    $[10] = t2;
  } else {
    t1 = $[9];
    t2 = $[10];
  }
  useEffect(t1, t2);
}
function _temp() {}